import React from "react";
import { Input, Card, Form, Row, Col } from "antd";
import Title from "antd/lib/typography/Title";
import NeedHelpIcon from "../NeedHelpIcon/NeedHelpIcon";

const { TextArea } = Input;

const StepAccountDetails: React.FC = () => {
  return (
    <Card style={{ width: "100%" }}>
      <Row style={{ justifyContent: "space-between", width: "100%" }}>
        <Col>
          <Title level={3}>Bruker</Title>
        </Col>
        <Col>
          <NeedHelpIcon />
        </Col>
      </Row>

      <Form.Item
        label="Brukernavn"
        name="username"
        rules={[
          {
            required: true,
            message: "Skriv inn brukernavn",
          },
          {
            pattern: new RegExp(/^[a-zA-Z@~`!@#$%^&*()_=+\\\\';:"\\/?>.<,-]+$/i),
            message: "Kun bokstaver",
          },
        ]}
        tooltip="Angi et brukernavn for bedriften du representerer. Benytt for eksempel navnet på bedriften din. Kun bokstaver og ingen mellomrom."
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Passord"
        name="password"
        rules={[
          {
            required: true,
            message: "Vennligst fyll inn passord",
          },
          {
            pattern: /^(?=.*[A-Z])(?=.*\W).{8,}$/,
            message: "Passordet må være minst 8 tegn langt med minst én stor bokstav og et symbol",
          },
        ]}
        hasFeedback
      >
        <Input.Password />
      </Form.Item>

      <Form.Item
        label="Bekreft passord"
        name="confirm"
        dependencies={["password"]}
        hasFeedback
        rules={[
          {
            required: true,
            message: "Vennligst bekreft passordet",
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error("De to passordene samsvarer ikke"));
            },
          }),
        ]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item
        label="Hvorfor ønsker dere å opprette en bruker hos Bindeleddet?"
        name="register_description"
        rules={[
          {
            required: true,
            message: "Vennligst fortell hvorfor dere ønsker å opprette en bruker",
          },
        ]}
      >
        <TextArea rows={4} />
      </Form.Item>
    </Card>
  );
};

export default StepAccountDetails;
